import { NotificationLevel } from "../models/notification.model";

export class ErrorModel {

  static UNKNOWN_ERROR = new ErrorModel(
    "ERROR.UNKNOWN",
    "",
    NotificationLevel.ERROR
  );

  static fromHttpError(error: unknown): ErrorModel {
    const candidate = error as { status?: unknown; status_code?: unknown } | null;
    const rawStatus = candidate?.status ?? candidate?.status_code;
    const status = typeof rawStatus === "number" ? rawStatus : Number(rawStatus);

    return new ErrorModel.Builder().build(Number.isFinite(status) ? status : undefined);
  }

  constructor(public readonly titleKey: string,
              public readonly descriptionKey: string,
              public readonly level: NotificationLevel,
              public readonly iconUrl?: string) {
    if (!iconUrl) {
      iconUrl = "'./assets/media/icons/duotune/files/fil015.svg'" // TODO assset
    }
  }
  
  static Builder = class {
    // not customizable
    private forbiddenErrorKey = "ERROR.FORBIDDEN";

    // customizable
    public unknownErrorKey = "ERROR.UNKNOWN";
    public emptyViewErrorKey = "ERROR.DEFAULT_EMPTY";
    public validationErrorKey = "ERROR.DEFAULT_VALIDATION";
    public iconUrl = "'./assets/media/icons/duotune/files/fil015.svg'"// TODO asset

    build(httpStatusCode?: number) {
      switch(httpStatusCode) {
        case 0: {
          return new ErrorModel("ERROR.NETWORK", "", NotificationLevel.ERROR);
        }
        case 400: {
            return new ErrorModel(
              this.validationErrorKey,
              "",
              NotificationLevel.ERROR)
        }
        case 401: {
          return new UnauthorizedErrorModel("", "")
        }
        case 403: { 
           return new ErrorModel(
             this.forbiddenErrorKey, "",
             NotificationLevel.WARNING)
        }
        case 404: {
          return new EmptyViewErrorModel(
            this.emptyViewErrorKey, "",
            this.iconUrl);
        }
        case 408: {
          return new ErrorModel("ERROR.TIMEOUT", "", NotificationLevel.WARNING);
        }
        case 409: {
          return new ErrorModel("ERROR.CONFLICT", "", NotificationLevel.WARNING);
        }
        case 422: {
          return new ErrorModel(
            this.validationErrorKey,
            "",
            NotificationLevel.ERROR)
        }
        case 429: {
          return new ErrorModel("ERROR.RATE_LIMIT", "", NotificationLevel.WARNING);
        }
        default: { 
           if (httpStatusCode !== undefined && httpStatusCode >= 500) {
             return new ErrorModel("ERROR.SERVER", "", NotificationLevel.ERROR);
           }
           return new ErrorModel(
             this.unknownErrorKey,
             "",
             NotificationLevel.ERROR);
        } 
      }
    }
  }
}

export class UnauthorizedErrorModel extends ErrorModel {
  constructor(titleKey: string, descriptionKey: string) {
    super(titleKey, descriptionKey, NotificationLevel.WARNING);
  }
}

export class EmptyViewErrorModel extends ErrorModel {
  constructor(
    titleKey: string,
    stringKey: string,
    iconUrl: string
    ) {
    super(titleKey, stringKey, NotificationLevel.WARNING, iconUrl);
  }
}
